// extracted by mini-css-extract-plugin
export var container = "_d2-0";
export var infoIcon = "_d2-2";
export var titleRowCol = "_d2-1";